import { gql } from '@apollo/client';
export const currentUserTeamIdsQuery = gql `
  query getCurrentUserTeamIds {
    teams(where: { isMember: true }) {
      id
    }
  }
`;
